import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Cookies from 'universal-cookie';
import SmartUserTable from '~/FielderElements/SmartUserTable/SmartUserTable';
import { FIELDER } from '@core/constants/base.constants';
import { useLanguage } from 'Context/LanguageContext';
import DatesFilterUtil from 'OldComponents/Analitics/DatesFilterUtil';
import { getRouteListRequest, doActionTrashRouteRequest } from '@core/api/route/route.service';
import model from 'Object/model/model';
import { useDispatch } from 'react-redux';
import { loadingStart, loadingStop } from '@core/store/modules/loading/loading.slice';
import DeleteIcon from '@assets/icons/delete-icon.svg';
import { useFielderSnackBar } from '~/FielderElements/useFielderSnackBar';
import ConfirmationDialog from '../../ConfirmationDialog/ConfirmationDialog';
import PermanenDeleteMessage from '../../PermanenDeleteMessage/PermanenDeleteMessage';
import request from 'FielderRequestTypes';
import RouteActionPopup from 'OldComponents/MyOperation/popups/routeAction-popup';
import RouteDetails from 'OldComponents/RouteDetails';

const cookieTable = new Cookies();
const cookieName = 'myOperationRoutePreferences';

const MyOperationRouteTaskTab = React.forwardRef((
	{ smartTable, changePopupState, closeRouteAction, ...rest }, ref) => {
	const lan = useLanguage();
	const dispatch = useDispatch();
	const fielderMsg = useFielderSnackBar();
	const [routes, setRoutes] = useState([]);
	const [routesIdAgents, setRoutesIdAgents] = useState([]);
	const [myIdRoutes, setMyIdRoutes] = useState([]);
	const [showRouteActionPopup, setShowRouteActionPopup] = useState(false);
	const [selectedRouteCount, setSelectedRouteCount] = useState(0);
	const [idRouteSelected, setIdRouteSelected] = useState();
	const [popups, setPopups] = useState({ routedetail: false });
	const [totalCount, setTotalCount] = useState(0);
	const [dateRange, setDateRange] = useState([null, null]);
	const [datesDropdownValues, setDatesDropdownValues] = useState([
		DatesFilterUtil.EXECUTION_PERIOD_TIME,
		DatesFilterUtil.EXECUTION_DATE,
	]);
	const [filter, setFilter] = useState(null);
	const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 50 });
	const [confirmationDialogRoute, setConfirmationDialogRoute] = useState(false);
	const [messageConfirmDeleteRoutes, setMessageConfirmDeleteRoutes] = useState('');
	const [listOfErrorDeleteRoute, setListOfErrorDeleteRoute] = useState([]);
	const [numberSuccess, setNumberSuccess] = useState(0);
	const [numberLinked, setNumberLinked] = useState(0);
	const [errormessageDelete, setErrormessageDelete] = useState(false);
	const [elementName, setElementName] = useState(lan.routes);
	const [messageElement, setMessageElement] = useState(lan.linkedTextAdministratador);
	const fetchRoutes = useCallback(() => {
		const offset = pagination.pageIndex * pagination.pageSize;
		const limit = pagination.pageSize;
		const dataViewTask = dateRange[1]
			? model.getViewRoute(
				offset,
				limit,
				dateRange[0]?.getDate(),
				dateRange[0]?.getMonth(),
				dateRange[0]?.getFullYear(),
				dateRange[1]?.getDate(),
				dateRange[1]?.getMonth(),
				dateRange[1]?.getFullYear(),
				filter
			)
			: (() => {
				const toDate = new Date();
				const fromDate = new Date();
				fromDate.setMonth(toDate.getMonth() - 1);
				return model.getViewRoute(
					offset,
					limit,
					fromDate.getDate(),
					fromDate.getMonth(),
					fromDate.getFullYear(),
					31,
					12,
					2099,
					filter
				);
			})();

		getRouteListRequest(dataViewTask, (res) => {
			const rows = res.routes.map(route => ({
				id: route.id,
				name: route.name,
				routeStatus: route.status,
				totalTasks: route.countTasks ?? lan.noneTasks,
				executionFormattedDate: route.executionFormattedDate,
				startedFormattedDate: route.startedFormattedDate,
				finishedFormattedDate: route.finishedFormattedDate,
				emergencies: route.countEmergencies ?? lan.noneEmergencies,
				agent: route.agent?.name ?? lan.unassigned,
				totalShipment: route.totalShipment,
			}));
			setRoutes(rows);
			setRoutesIdAgents(res.routes.map(r => r.agent?.idAgent));
			setMyIdRoutes(res.routes.map(r => r.id));
			setTotalCount(res.count);
			dispatch(loadingStop('myOperation'));
		});
	}, [pagination, dateRange, filter]);
	useEffect(() => {
		fetchRoutes();
	}, [fetchRoutes]);
	const handlePaginationChange = ({ pageIndex, pageSize }) =>
		setPagination({ pageIndex, pageSize });
	const handleDateRangeChange = ([from, to]) => setDateRange([from, to]);
	const handleDatesDropdownApply = (values) => setDatesDropdownValues(values);
	const handleDeleteFilter = (val) => setFilter(val);
	const handleResetFilter = () => setFilter(null);
	const handleFilter = () => fetchRoutes();
	const getSelectedIdRoutes = useCallback((rows) => {
		const ids = [];
		if (rows && rows.length) {
			for (let i = 0; i < rows.length; i++) {
				ids.push(rows[i].id);
			}
		}
		return ids;
	}, []);
	const closeDeleteConfirmationDialogRoute = () => setConfirmationDialogRoute(false);
	const showMessageDelete = () => setErrormessageDelete(false);
	const onRowClick = useCallback((rowId, row) => {
		if (row) {
			setPopups(p => ({ ...p, routedetail: true }));
			setIdRouteSelected(row.id);
		}
		setShowRouteActionPopup(false);
	}, []);
	const handleRouteCheck = useCallback((selectedIndexes) => {
		if (selectedIndexes.length !== 0) {
			setSelectedRouteCount(selectedIndexes.length);
			setShowRouteActionPopup(true);
		} else {
			setShowRouteActionPopup(false);
		}
	}, []);
	const closeRouteActionLocal = useCallback(() => {
		setShowRouteActionPopup(false);
		if (closeRouteAction) closeRouteAction();
	}, [closeRouteAction]);
	const handleCloseRouteDetails = () => {
		setPopups(p => ({ ...p, routedetail: false }));
		setIdRouteSelected(undefined);
	};
	const disableRoute = useCallback((i, idRoutes, linked, success, errors) => {
		dispatch(loadingStart({ name: 'myOperation' }));
		const loadingConfig = { dispatch };
		if (i < idRoutes.length) {
			const body = request.getRequestDoActionTrashRoute(idRoutes[i]);
			const onSuccess = () => {
				errors.push({ idRoute: idRoutes[i], statusCode: 0 });
				success += 1;
			};
			const onError = ({ status }) => {
				errors.push({ idRoute: idRoutes[i], statusCode: status });
				linked += 1;
			};
			doActionTrashRouteRequest(body, onSuccess, onError, loadingConfig).then(() => {
				disableRoute(i + 1, idRoutes, linked, success, errors);
			});
		} else {
			setConfirmationDialogRoute(false);
			setListOfErrorDeleteRoute(errors);
			setNumberSuccess(success);
			setNumberLinked(linked);
			setElementName(lan.routes);
			setErrormessageDelete(true);
			fetchRoutes();
			dispatch(loadingStop('myOperation'));
		}
	},
		[dispatch, fetchRoutes, lan]);
	const handlerActionDeleteRoutes = useCallback(() => {
		dispatch(loadingStart({ name: 'myOperation' }));
		const stateTable = smartTable.current.getState();
		const ids = getSelectedIdRoutes(stateTable.selectedRows);
		const listErrors = [];
		disableRoute(0, ids, 0, 0, listErrors);
	},
		[dispatch, smartTable, getSelectedIdRoutes, disableRoute]);
	const handleDeleteRoute = useCallback(() => {
		const stateTable = smartTable.current.getState();
		const routes = getSelectedIdRoutes(stateTable.selectedRows);
		const canDelete = routes.length > 0;
		dispatch(loadingStop('myOperation'));
		if (canDelete) {
			setMessageConfirmDeleteRoutes(lan.messageConfirmDeleteRoutes);
			setConfirmationDialogRoute(true);
		} else {
			fielderMsg({
				title: lan.myOperation,
				message: lan.messageEmptyRoutes,
				variant: 'error',
				closeButton: true,
				duration: 7000,
			});
		}
	},
		[smartTable, getSelectedIdRoutes, dispatch, lan, fielderMsg]);
	return (
		<>
			{popups.routedetail ? (
				<RouteDetails
					{...rest}
					onClose={handleCloseRouteDetails}
					idRoute={idRouteSelected}
				/>
			) : (
				<SmartUserTable
					smartTableId={FIELDER.smartTableId.ROUTES}
					ref={smartTable}
					elements={routes}
					onCheckBoxSelected={handleRouteCheck}
					showCheckboxComponent={true}
					cookieTable={cookieTable}
					cookieName={cookieName}
					paginationHidden={false}
					height={"calc(85vh - 200px)"}
					onRowClick={onRowClick}
					customActions={[{
						icon: DeleteIcon,
						toolTip: lan.deleteRouteTooltip,
						action: handleDeleteRoute,
					}]}
					onPaginationChange={handlePaginationChange}
					totalCount={totalCount}
					enableDefaultActions={false}
					auxToolbarRoute={{
						lan,
						totalNumberOfElements: totalCount,
						titleElement: lan.routes,
						dateRange,
						onDateRangeChange: handleDateRangeChange,
						datesDropdownValues,
						onDatesDropdownApply: handleDatesDropdownApply,
						showFilter: true,
						handleFilter,
						handleDeleteFilter,
						handlerEventKey: (e) => e.charCode === 13 && handleFilter(),
						handleResetFilter,
						filter,
					}}
				/>
			)}
			{confirmationDialogRoute && (
				<ConfirmationDialog
					lan={lan}
					handleAction={handlerActionDeleteRoutes}
					handleClose={closeDeleteConfirmationDialogRoute}
					message={messageConfirmDeleteRoutes}
				/>
			)}
			{errormessageDelete && (
				<PermanenDeleteMessage
					lan={lan}
					numberSuccess={numberSuccess}
					numberLinked={numberLinked}
					closeErrorMessage={showMessageDelete}
					showErrorMessage={true}
					messageElement={messageElement}
					elementName={elementName}
				/>
			)}
			{showRouteActionPopup && (
				<RouteActionPopup
					{...rest}
					selectedRouteCount={selectedRouteCount}
					changePopupState={changePopupState}
					closeRouteAction={closeRouteActionLocal}
				/>
			)}
		</>
	);
});

export default MyOperationRouteTaskTab;
